// extracted by mini-css-extract-plugin
export default {"modal":"SubMenuEstudiantes_modal__WrCPg","botones":"SubMenuEstudiantes_botones__uMaex"};